import { render, staticRenderFns } from "./pension-trabajadores-alto-riesgo.vue?vue&type=template&id=c2ba763e&"
import script from "./pension-trabajadores-alto-riesgo.vue?vue&type=script&lang=js&"
export * from "./pension-trabajadores-alto-riesgo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports